/*
 * @Author: dali
 * @Date: 2021-12-08 14:51:58
 * @LastEditors: 陈威达
 * @LastEditTime: 2023-06-08 18:43:18
 * @FilePath: \gerlun-react-website\src\const\const.js
 * @Description:
 */
export const SYSCON = {
  TryType: 'try',
  BuyType: 'buy',

  Token: 'htoken',
  GelFinanceChangePws: 'GEL_FINANCE_changePws',

  RememberLocal: 'remember',
  LastUserLocal: 'lastUser',
  orgIdLocal: 'orgId',
  orgNmLocal: 'orgNm',

  ProductNm: '智能财务管理系统',

  PlatAppSmarterFin: '9050.150', // 智能财务管理系统
  PlatAppWorkbench: '9050.170', // 用户工作台
  PlatAppExpense: '9050.175', // 报销管理系统
  PlatAppInvoice: '9050.180', // 在线开票

  PlatMicroApp: '9060', // 平台小程序/网站应用/公众号
  PlatMicroAppFinComn: '9060.150', // 概而论云记账
  PlatMicroAppFinPlatinumEdition: '9060.160', // 概而论代账端
  PlatMicroAppFinWeb: '9060.170', // 概而论财务网页应用
  PlatMicroAppFinMp: '9060.180', // 概而论公众号

  UserType: '2200', // 用户类别
  UserTypePersonal: '2200.155', // 企业或个人用户
  UserTypeOrg: '2200.160', // 财税服务机构
  UserTypeAgency: '2200.165', // 代账机构

  OrgType: '2210', // 组织类别
  OrgTypePersonal: '2210.155', // 个人组织
  OrgTypeCorp: '2210.160', // 多组织

  DocSrcTax: '3970.10', // 宁波税务网
  DocSrcRegulatory: '3970.15', // 法规库

  ProdTrialSrcMicroAppDouyin: '200027.10', // 抖音小程序 渠道
  ProdTrialSrcWebsitePC: '200027.20', // 官网PC端
  ProdTrialSrcWebsiteMobile: '200027.30', // 官网手机端
  ProdTrialSrcWorkbench: '200027.40', // 企业工作台
  ProdTrialSrcWxMp: '200027.50', // 微信公众号

  UserSrc: '2201', // 用户来源
  UserSrcOfficWebPC: '2201.100', // 官网PC端注册
  UserSrcOfficWebMobile: '2201.110', // 官网移动端注册
  UserSrcES: '2201.120', // 企服网页注册
  UserSrcESApp: '2201.130', // 企服APP注册
  UserSrcInviteStaff: '2201.140', // 邀请为财务
  UserSrcInviteBusiOwner: '2201.150', // 邀请为老板
  UserSrcCustSvc: '2201.160', // 客服创建
  UserSrcProdInviter: '2201.170' // 邀请人创建
}
